import { memo } from "react";
import { clockOf } from "./rules/format";
import { KIND_PATHS, iconOf } from "./constants";
import Shot from "./Shot";

const DETAIL_KINDS = ["audio", "video"];

const KindIcon = ({ kind }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">{KIND_PATHS[iconOf(kind)].map((d) => <path key={d} d={d} />)}</svg>
);

/**
 * One check in the review queue: what it was, where and when; open, the evidence.
 * Kept from re-rendering with the clock: it takes `live` as a flag, and its evidence only when open.
 */
function QueueItem({
  x, open, live, analysis, where, thumbUrl,
  onToggle, onImageError, children,
}) {
  const cls = [
    "proctoring-review__item",
    open ? "is-open" : "",
    live && !open ? "is-live" : "",
  ].filter(Boolean).join(" ");
  return (
    <li className={cls} data-key={x.key} data-severity={x.severity}>
      <button type="button" className="proctoring-review__item-head" onClick={() => onToggle(x)} aria-expanded={open} data-room-enter="">
        {x.kind === "capture" || x.kind === "screen"
          ? <span className={`proctoring-review__thumb${x.flagged ? " is-flag" : ""}`}><Shot url={thumbUrl} alt="" onError={onImageError} /></span>
          : <span className="proctoring-review__kind-icon"><KindIcon kind={x.kind} /></span>}
        <span className="proctoring-review__item-main">
          <b>{x.what}</b>
          <span>
            <i className={`proctoring-review__sev proctoring-review__sev--${x.severity}`} />
            {`${analysis}${where ? ` · ${where}` : ""}${x.questionLabel ? ` · ${x.questionLabel}` : ""}`}
            {x.experimental && <em className="proctoring-review__badge proctoring-review__badge--experimental">Experimental</em>}
          </span>
        </span>
        <span className="proctoring-review__item-time" title={x.approx ? "Placed approximately on the clock" : undefined}>
          {x.approx && <em className="proctoring-review__approx">approx</em>}
          {clockOf(x.at)}
        </span>
      </button>
      {open && (
        <div className="proctoring-review__item-body">
          {children}
          {x.detail && DETAIL_KINDS.includes(x.kind) && <p className="proctoring-review__detail">{x.detail}</p>}
        </div>
      )}
    </li>
  );
}

export default memo(QueueItem);
